export default function Leadership() {
  const executives = [
    {
      position: '代表取締役',
      name: '城下隆'
    },
    {
      position: '取締役',
      name: '梶原功司'
    },
    {
      position: '取締役',
      name: '森健二'
    }
  ];

  const advisors = [
    {
      name: '張振亜',
      title: '筑波大学 名誉教授'
    },
    {
      name: '高橋幸則',
      title: '水産大学校 名誉教授'
    }
  ];

  return (
    <section className="py-24 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        {/* 役員 */}
        <div className="mb-20">
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">役員</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {executives.map((exec, index) => (
              <div key={index} className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
                <div className="text-center">
                  <div className="w-20 h-20 bg-gradient-to-br from-emerald-400 to-teal-500 rounded-full mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-user-line text-3xl text-white"></i>
                  </div>
                  <p className="text-sm font-medium text-emerald-600 mb-2">{exec.position}</p>
                  <h3 className="text-xl font-bold text-gray-900">{exec.name}</h3>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* 技術顧問 */}
        <div>
          <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">技術顧問</h2>
          <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
            {advisors.map((advisor, index) => (
              <div key={index} className="bg-white rounded-lg p-8 shadow-sm hover:shadow-md transition-shadow">
                <div className="flex items-start gap-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-cyan-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-graduation-cap-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 className="text-xl font-bold text-gray-900 mb-2">{advisor.name}</h3>
                    <p className="text-sm text-gray-600 leading-relaxed">{advisor.title}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}